module.exports = __webpack_public_path__ + "static/media/google_logo.80e2d241.svg";